export default (errorMessage, status) =>
  new Error({
    response: {
      status,
      data: {
        message: errorMessage,
      },
    },
  });
